export default "__VITE_ASSET__ChXwjH6Q__"